module.exports = __webpack_public_path__ + "static/media/potential-2.da7f8555.svg";